import VehicleInfo from './styled';

export { default as VehicleType } from './VehicleType';
export { default as VehiclePlateNumber } from './VehiclePlateNumber';
export { default as VehicleMaxPallets } from './VehicleMaxPallets';
export { default as VehicleMaxWeight } from './VehicleMaxWeight';
export { default as VehicleContainerHeight } from './VehicleContainerHeight';
export { default as VehicleContainerWidth } from './VehicleContainerWidth';
export { default as VehicleLifgateIcon } from './VehicleLifgateIcon';
export { default as VehicleLateralLoadingIcon } from './VehicleLateralLoadingIcon';

export default VehicleInfo;
